var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCubeAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M14 2h1a1 1 0 0 1 0 2h-1v1a1 1 0 0 1-2 0V4h-1a1 1 0 0 1 0-2h1V1a1 1 0 0 1 2 0v1ZM9.136.65a3.001 3.001 0 0 0 .992 5.222c.018.058.038.115.059.172L8 7.41 1.806 3.54 7.504.283a1 1 0 0 1 .992 0l.64.365ZM15 7.235v4.184a1 1 0 0 1-.504.868L8.5 15.714V8.277l2.187-1.367A2.994 2.994 0 0 0 13 8c.768 0 1.47-.289 2-.764ZM1.056 4.25 7.5 8.277v7.437l-5.996-3.426A1 1 0 0 1 1 11.42V4.58a1 1 0 0 1 .056-.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCubeAdd);
export default __webpack_public_path__ + "static/media/cube-add.57c814ef4d1f48fd6874b154f601fd78.svg";
export { ForwardRef as ReactComponent };